<script>
  import { Search } from 'lucide-svelte';

  export let visible = false;
  export let x = 0;
  export let y = 0;
  export let onClose = () => {};
  export let onViewOriginal = () => {};
</script>

{#if visible}
  <button class="fixed inset-0 z-40 cursor-default" type="button" aria-label="Đóng menu" onclick={onClose}></button>

  <div
    class="fixed z-50 w-44 rounded-lg border border-slate-200 bg-white py-1 shadow-xl"
    style="left:{x}px; top:{y}px">
    <button
      class="flex w-full items-center gap-2 px-4 py-2 text-left text-[13px] text-slate-700 hover:bg-slate-50"
      type="button"
      onclick={onViewOriginal}>
      <Search size={14} />
      Xem tin gốc
    </button>
  </div>
{/if}
